import { Component, Inject, Prop, Vue } from 'vue-property-decorator';
import { Store } from '@/primary/store/Store';
import { ProjectDataSet, toProjectDataSet } from '@/primary/template-right-bar/project/ProjectDataSet';
import { ResearchUnitRepository } from '@/domain/research-unit/ResearchUnitRepository';
import { ComponentState } from '@/primary/ComponentState';
import { Logger } from '@/domain/Logger';

@Component
export default class ProjectSidebarComponent extends Vue {
  project!: ProjectDataSet;
  state = ComponentState.PENDING;

  @Inject()
  private researchUnitRepository!: () => ResearchUnitRepository;

  @Inject()
  private store!: () => Store;

  @Inject()
  private logger!: () => Logger;

  @Prop({ type: Number, required: true })
  readonly projectId!: number;

  created() {
    const project = this.store()
      .getProjects()
      .find(project => project.id === this.projectId)!;
    this.researchUnitRepository()
      .list()
      .then(researchUnits => {
        const projectResearchUnits = researchUnits.filter(researchUnit => project.researchUnits.includes(researchUnit.id));
        this.project = toProjectDataSet(project, projectResearchUnits);
        this.state = ComponentState.SUCCESS;
      })
      .catch(error => this.error(error));
  }

  private error(error: Error) {
    this.logger().error('Fail to retrieve research unit list', error);
    this.state = ComponentState.ERROR;
  }
}
